/* RHINOS REEF - Blacklight Reef Lab interactions */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Pause autoplay hero video for reduced-motion users */
  if (reduce) {
    var pauseHeroVideos = function () {
      Array.prototype.forEach.call(document.querySelectorAll('.rr-hero__video'), function (v) {
        try { v.pause(); v.removeAttribute('autoplay'); } catch (e) {}
      });
    };
    if (document.readyState !== 'loading') { pauseHeroVideos(); } else { document.addEventListener('DOMContentLoaded', pauseHeroVideos); }
  }

  /* UV blacklight cursor glow */
  if (!reduce && window.matchMedia('(pointer: fine)').matches) {
    var uv = document.querySelector('.rr-uv');
    if (uv) {
      var raf = null;
      window.addEventListener('pointermove', function (e) {
        uv.style.opacity = '1';
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          uv.style.left = e.clientX + 'px';
          uv.style.top = e.clientY + 'px';
        });
      });
      window.addEventListener('pointerleave', function () {
        uv.style.opacity = '0';
      });
    }
  }

  /* Scroll reveal for elements marked .rr-reveal (used by custom sections) */
  function initReveal() {
    var items = document.querySelectorAll('.rr-reveal:not(.rr-in)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('rr-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rr-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Sticky add-to-cart: drives and mirrors the main product form */
  function initStickyAtc() {
    var bar = document.querySelector('[data-rr-satc]');
    if (!bar || bar.dataset.satcInit) return;
    var mainAtc = document.querySelector('.product-form__submit');
    if (!mainAtc) return;
    bar.dataset.satcInit = '1';

    var addBtn = bar.querySelector('[data-rr-satc-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () { mainAtc.click(); });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -10% 0px' }).observe(mainAtc);
    } else {
      bar.classList.add('is-visible');
    }

    var syncDisabled = function () { if (addBtn) addBtn.disabled = mainAtc.disabled; };
    syncDisabled();
    new MutationObserver(syncDisabled).observe(mainAtc, { attributes: true, attributeFilter: ['disabled'] });

    var price = bar.querySelector('[data-rr-satc-price]');
    var mainPrice = document.querySelector('.product__info-container .price, .product .price');
    if (price && mainPrice) {
      var mirror = function () {
        var item = mainPrice.querySelector('.price-item--sale:not([hidden]), .price-item--regular');
        if (item && item.textContent.trim()) price.textContent = item.textContent.trim();
      };
      mirror();
      new MutationObserver(mirror).observe(mainPrice, { subtree: true, childList: true, characterData: true });
    }
  }

  function initAll() { initReveal(); initStickyAtc(); }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  /* Re-init when sections are added/edited in the theme editor */
  document.addEventListener('shopify:section:load', initAll);
})();
